import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {

  connect() {
    document.addEventListener('tableRowReorder', (event) => {
        this.reorderPokemon(event.detail.activeId, event.detail.overId);
      });
  }

  async reorderPokemon (id, position) {
    const request = new FetchRequest('patch', `/pokedexes/reorder`, { 
      body: JSON.stringify({ 
        id: id,
        position: position 
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    try {
      const response = await request.perform()
      if (response.ok) {
        const result = await response.json
        console.log('Reorder successful:', result);
      } else {
        const error = await response.json
        console.error('Reorder failed:', error);
      }
    } catch (error) {
      console.error('Reorder request failed:', error);
    }
  }
}